import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getCampaignValue, getMediaSourceValue, getParameterFromURL, isFacebook, setGenericParameter, stringifyAfParameters } from './utils';
export var UrlGenerator = /*#__PURE__*/function () {
  function UrlGenerator(_ref) {
    var _ref$campaignKeysList = _ref.campaignKeysList,
        campaignKeysList = _ref$campaignKeysList === void 0 ? [] : _ref$campaignKeysList,
        _ref$campaignStaticVa = _ref.campaignStaticValue,
        campaignStaticValue = _ref$campaignStaticVa === void 0 ? null : _ref$campaignStaticVa,
        _ref$gclIdParam = _ref.gclIdParam,
        gclIdParam = _ref$gclIdParam === void 0 ? 'af_sub5' : _ref$gclIdParam,
        oneLinkURL = _ref.oneLinkURL,
        _ref$pidKeysList = _ref.pidKeysList,
        pidKeysList = _ref$pidKeysList === void 0 ? [] : _ref$pidKeysList,
        _ref$pidOverrideList = _ref.pidOverrideList,
        pidOverrideList = _ref$pidOverrideList === void 0 ? {} : _ref$pidOverrideList,
        _ref$pidStaticValue = _ref.pidStaticValue,
        pidStaticValue = _ref$pidStaticValue === void 0 ? null : _ref$pidStaticValue;

    _classCallCheck(this, UrlGenerator);

    _defineProperty(this, "afParams", void 0);

    _defineProperty(this, "campaign", void 0);

    _defineProperty(this, "campaignKeysList", void 0);

    _defineProperty(this, "campaignStaticValue", void 0);

    _defineProperty(this, "gclIdParam", void 0);

    _defineProperty(this, "mediaSource", void 0);

    _defineProperty(this, "oneLinkURL", void 0);

    _defineProperty(this, "pidKeysList", void 0);

    _defineProperty(this, "pidOverrideList", void 0);

    _defineProperty(this, "pidStaticValue", void 0);

    this.campaignKeysList = campaignKeysList;
    this.campaignStaticValue = campaignStaticValue;
    this.gclIdParam = gclIdParam;
    this.oneLinkURL = oneLinkURL;
    this.pidKeysList = pidKeysList;
    this.pidOverrideList = pidOverrideList;
    this.pidStaticValue = pidStaticValue;
    this.campaign = getCampaignValue(this.campaignKeysList, this.campaignStaticValue);
    this.mediaSource = getMediaSourceValue(this.pidKeysList, this.pidStaticValue, this.pidOverrideList);
    this.afParams = {
      af_js_web: 'true'
    };
  }

  _createClass(UrlGenerator, [{
    key: "generateUrl",
    value: function generateUrl() {
      if (this.mediaSource === null) {
        return null;
      }

      if (getParameterFromURL('af_redirect')) {
        return null;
      }

      if (isFacebook()) {
        return null;
      }

      var pidValue = this.mediaSource;
      var gclIdValue = getParameterFromURL('gclid');

      if (gclIdValue) {
        this.afParams[this.gclIdParam] = gclIdValue;
        var kwValue = getParameterFromURL('keyword');

        if (kwValue) {
          this.afParams['af_keywords'] = kwValue;
        }
      }

      return "".concat(this.oneLinkURL, "?pid=").concat(pidValue, "&c=").concat(this.campaign).concat(stringifyAfParameters(this.afParams));
    }
  }, {
    key: "setDeepLinkValue",
    value: function setDeepLinkValue(deepLinkValueParam) {
      var deepLinkValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'deep_link_value', deepLinkValueParam, deepLinkValue);
    }
  }, {
    key: "setDeepLinkSub5",
    value: function setDeepLinkSub5(deepLinkValue) {
      if (deepLinkValue) {
        this.afParams['deep_link_sub5'] = deepLinkValue;
      }
    }
  }, {
    key: "setChannel",
    value: function setChannel(channelParam) {
      var channelValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_channel', channelParam, channelValue);
    }
  }, {
    key: "setAdset",
    value: function setAdset(adsetParam) {
      var adsetValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_adset', adsetParam, adsetValue);
    }
  }, {
    key: "setAd",
    value: function setAd(adParam) {
      var adValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_ad', adParam, adValue);
    }
  }, {
    key: "setAfSub1",
    value: function setAfSub1(afSub1Param) {
      var afSub1Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub1', afSub1Param, afSub1Value);
    }
  }, {
    key: "setAfSub2",
    value: function setAfSub2(afSub2Param) {
      var afSub2Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub2', afSub2Param, afSub2Value);
    }
  }, {
    key: "setAfSub3",
    value: function setAfSub3(afSub3Param) {
      var afSub3Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub3', afSub3Param, afSub3Value);
    }
  }, {
    key: "setAfSub4",
    value: function setAfSub4(afSub4Param) {
      var afSub4Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub4', afSub4Param, afSub4Value);
    }
  }, {
    key: "setAfSub5",
    value: function setAfSub5(afSub5Param) {
      var afSub5Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub5', afSub5Param, afSub5Value);
    }
  }, {
    key: "setCustomParameter",
    value: function setCustomParameter(searchKey, customKey) {
      var customValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      setGenericParameter(this.afParams, customKey, searchKey, customValue);
    }
  }]);

  return UrlGenerator;
}();